<div class="simplified-container">
  <div class="flex justify-center">
    <div class="account-container">
      <form [formGroup]="recurringReviewForm" (ngSubmit)="submit()">
        <div class="flex payment">
          <span
            data-cy="reviewHeading"
            class="reviewHeading"
            dsContent
            [contentPath]="'billing.phoenixPayment.reviewHeading'"
          ></span>
          <div class="account-box" style="margin-top: 24px">
            <div class="risk-pill">
              <span class="icon"
                ><img
                  src="/assets/images/Layer_1.svg"
                  alt="payment review image"
                  data-cy="paymentReviewImage"
              /></span>
              <span data-cy="reviewSubheading" class="reviewSubheading">{{
                reviewSubheading
              }}</span>
            </div>
            <ds-payment-details
              [data]="data"
              [riskDescription]="riskDescription"
              [isRecurringPage]="true"
              [amountSubheading]="amountSubheading"
            />
          </div>
          <div class="row" style="margin-bottom: 0px; margin-top: 24px">
            <ds-amfam-dsn-alert
              [action]="false"
              [icon]="true"
              [dismiss]="false"
              [type]="'info'"
              [message]="alertMessage"
              [applyMargin]="false"
            >
            </ds-amfam-dsn-alert>
          </div>
          <ds-legal-disclosure [authorizeText]="authorizeText"></ds-legal-disclosure>
          <div class="row" style="margin-top: 24px">
            <p
              dsContent
              [contentPath]="'billing.recurring.electronicSignature'"
              for="electronicSignature"
              class="subheading"
            ></p>
            <ds-form-control-container
              [control]="recurringReviewForm.controls.electronicSignature"
              [validateOnSubmit]="submitted"
            >
              <input
                id="electronicSignature"
                formControlName="electronicSignature"
                data-cy="electronicSignature"
                type="text"
                class="fill"
              />
              <ds-form-control-message
                [control]="recurringReviewForm.controls.electronicSignature"
                [validateOnSubmit]="submitted"
              ></ds-form-control-message>
            </ds-form-control-container>
            <span
              dsContent
              [contentPath]="'billing.recurring.electronicSignatureSubtext'"
              class="amountSubtext"
            ></span>
          </div>
          <div style="margin-top: 24px">
            <call-to-action
              [primaryButtonName]="primaryButtonName"
              [displayBackButton]="false"
              [secondaryButtonName]="secondaryButtonName"
              (secondaryEvent)="goBackOneStep()"
              [fullWidthButtons]="true"
            >
            </call-to-action>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
